
//todo moath refactor
import axios from "axios";
import constants from '@/assets/js/constants.js';

export default class FormBuilderUtil {
    constructor(formDetailsToSend) {
        this.formDetailsToSend = formDetailsToSend;
    }

    formDetailsToSend = [];
    dynamicFormDetailsFromDb = [];
    dynamicFormDetailsFromDbFormMultipleStructure = [];
    formsHtmlElements = [];

    //moath need enhancement we can remove this call
    initializeFormio() {
        var filter = this.formDetailsToSend;
        filter.forEach(formData => {
            console.log('[FormBuilderUtil.initializeFormio] Calling DynamicForms/Filter', {
                url: constants.baseApiUrl + 'DynamicForms/Filter',
                formData: formData,
                timestamp: new Date().toISOString(),
                callerStack: new Error().stack
            });
            axios.post(constants.baseApiUrl + 'DynamicForms/Filter', formData)
                .then((res) => {
                    console.log('[FormBuilderUtil.initializeFormio] Response received', { data: res.data });
                    if (res) {
                        this.dynamicFormDetailsFromDb.push(res.data);
                        //console.log(res.data);
                    }
                })
                .catch((err) => {
                    console.error('[FormBuilderUtil.initializeFormio] Error:', {error: err, url: constants.baseApiUrl + 'DynamicForms/Filter'});
                })
                .finally(() => {

                })
        })
    }

    registerEventsToForms(formCallBackHandler) {
        //
        if (this.dynamicFormDetailsFromDb.length) {

            this.dynamicFormDetailsFromDb.forEach(actionButtonName => {
                var formElement = document.getElementsByName(actionButtonName.submitButtonName)[0];
                if (formElement) {
                    //formElement.addEventListener('jsonData', (x) => formCallBackHandler);
                    this.formsHtmlElements.push(formElement);
                } else {
                    console.log(`button ${submitButtonName} cannot be found`)
                }
            })
            window.hideLoading();
        }
        else {
            setTimeout(() => {
                this.registerEventsToForms(formCallBackHandler);
            }, 1000);
        }
    }

    invokeAllSubmit() {
        this.formsHtmlElements.forEach(formElement => {
            formElement.click.apply(formElement);
        })
    }

    invoke(formData, callBackFunction) {
        //moath this call should replaced with single call for backend
        // if (
        //     formData.structureId
        //     && formData.structureId != 0
        //     && formData.structureId != ''
        //     && formData.structureId != '0') {
        if (
            formData.structureId
            && formData.structureId != 0
            && formData.structureId != ''
            && formData.structureId != '0'
            && (
                !formData.templateId ||
                formData.templateId == '0' 
                )
            ) {
            const getUrl = constants.baseApiUrl + `DynamicForms/IsAnyParentHaveTemplate?structureId=${formData.structureId}&categoryId=${formData.categoryId}`;
            console.log('[FormBuilderUtil.invoke] Calling DynamicForms/IsAnyParentHaveTemplate (if branch)', {
                url: getUrl,
                structureId: formData.structureId,
                categoryId: formData.categoryId,
                timestamp: new Date().toISOString(),
                callerStack: new Error().stack
            });
            axios.get(getUrl)
                .then((res) => {
                        console.log('[FormBuilderUtil.invoke] Response received', { data: res.data });
                        window.addEventListener(res.data[0].submitButtonName, callBackFunction);
                        var formElement = document.getElementsByName(res.data[0].submitButtonName)[0];
                        formElement.click.apply(formElement);
                })
                .catch((err) => {
                    console.error('[FormBuilderUtil.invoke] Error on GET:', {error: err, url: getUrl});
                })
                .finally(() => {

                })
        }
        else {
            const callUrl = constants.baseApiUrl + 'DynamicForms/Filter';
            console.log('[FormBuilderUtil.invoke] Calling DynamicForms/Filter (else branch)', {
                url: callUrl,
                formData: formData,
                timestamp: new Date().toISOString(),
                callerStack: new Error().stack
            });
            axios.post(callUrl, formData)
                .then((res) => {
                    console.log('[FormBuilderUtil.invoke] Response received', { data: res.data });
                    //todo moath this should be changed from window event to custom element event
                    window.addEventListener(res.data.submitButtonName, callBackFunction);
                    var formElement = document.getElementsByName(res.data.submitButtonName)[0];
                    formElement.click.apply(formElement);
                    //console.log(res.data);
                })
                .catch((err) => {
                    console.error('[FormBuilderUtil.invoke] Error:', {error: err, url: callUrl});
                })
                .finally(() => {

                })
        }
    }

    initializeFormioForMultipleStructure(structureId) {

        var filter = this.formDetailsToSend;
        filter.forEach(formData => {
            const getUrl = constants.baseApiUrl + `DynamicForms/IsAnyParentHaveTemplate?structureId=${structureId}`;
            console.log('[FormBuilderUtil.initializeFormioForMultipleStructure] Calling DynamicForms/IsAnyParentHaveTemplate', {
                url: getUrl,
                structureId: structureId,
                timestamp: new Date().toISOString(),
                callerStack: new Error().stack
            });
            axios.get(getUrl)
                .then((res) => {
                    console.log('[FormBuilderUtil.initializeFormioForMultipleStructure] Response received:', res.data);
                    if (res) {
                        this.dynamicFormDetailsFromDbFormMultipleStructure = res.data;
                        this.generateHtmlForFormForMultipleStructure(this.dynamicFormDetailsFromDbFormMultipleStructure);
                    }
                })
                .catch((err) => {
                    console.error('[FormBuilderUtil.initializeFormioForMultipleStructure] Error:', {error: err, url: getUrl});
                })
                .finally(() => {

                })
        })
    }

    generateHtmlForFormForMultipleStructure(allStructureTemplates) {
        console.log("multiple structure id data" + JSON.stringify(allStructureTemplates));
        var collectJsonData = { components: [] };
        var jsonData = [];
        allStructureTemplates.forEach(structure => {
            jsonData = JSON.parse(structure.jsonData);
            jsonData.components.forEach(c => {
                collectJsonData.components.push(c);
            });
        });
    }

}

